var exports = {
  "Sw": "GuildFolderItem.module__folderContainer___c2Zfdl",
  "V8": "GuildFolderItem.module__relative___c2Zfdl",
  "o6": "GuildFolderItem.module__collapsedFolder___c2Zfdl",
  "yx": "GuildFolderItem.module__collapsedFolderBackground___c2Zfdl",
  "sD": "GuildFolderItem.module__miniGuildIcon___c2Zfdl",
  "jD": "GuildFolderItem.module__miniGuildIconWithInitials___c2Zfdl",
  "Q5": "GuildFolderItem.module__miniGuildInitials___c2Zfdl",
  "mw": "GuildFolderItem.module__folderBadge___c2Zfdl",
  "M8": "GuildFolderItem.module__folderBadgeActive___c2Zfdl",
  "k9": "GuildFolderItem.module__expandedFolderBackground___c2Zfdl",
  "MJ": "GuildFolderItem.module__folderHeader___c2Zfdl",
  "mK": "GuildFolderItem.module__folderHeaderButton___c2Zfdl",
  "Eh": "GuildFolderItem.module__folderIcon___c2Zfdl",
  "QD": "GuildFolderItem.module__expandedGuilds___c2Zfdl",
  "h5": "GuildFolderItem.module__folderTooltipContainer___c2Zfdl",
  "bO": "GuildFolderItem.module__folderTooltipName___c2Zfdl",
  "Il": "GuildFolderItem.module__dropIndicatorTop___c2Zfdl",
  "Yc": "GuildFolderItem.module__dropIndicatorBottom___c2Zfdl",
  "Zg": "GuildFolderItem.module__dropIndicatorInside___c2Zfdl",
};

module.exports = exports;
